import { Component } from 'vue-property-decorator';
import Vue from '@/VueBase';
import { mapState } from 'vuex';
import helper from '@/services/helper';
import api from '@/services/api';
import Q from 'q';

@Component({
  computed: {
    ...mapState(['IsAuthenticated']),
  },
})
export default class HeaderMixins extends Vue {
  public readonly IsAuthenticated!: boolean;
  public readonly Client: string = process.env.VUE_APP_CLIENT;

  get StationFullName() {
    if (process.env.VUE_APP_MODE === 'WEB') return '';
    if (process.env.VUE_APP_MODE === 'SA' || process.env.VUE_APP_MODE === 'CS') {
      return (this.$store.state.BallotNumber || '') + '' + (this.$store.state.StationNumber || '');
    }
  }

  async OpenAdmin() {
    if (!this.IsAuthenticated) return;
    var logoutRouteNames = ['VoterAssign', 'Start', 'Login'];

    if (logoutRouteNames.indexOf(this.$route.name || '') === -1) {
      return;
    }

    var psw = await helper.swalPrompt({
      title: this.$t('vs.popup.admin.placeholder') as string,
      showCloseButton: true,
    }, 'password');
    
    if (!psw) return;
    helper.swalShowLoading();
    let isValid = await (await api.CheckPassword(psw)).getData();
    if (!isValid) return;

    this.$modal.show('admin', psw as any);
    helper.close();
  }

  async CancelVote() {
    if (process.env.VUE_APP_MODE === 'SA' || process.env.VUE_APP_MODE === 'CS') {
      var logoutRouteNames = ['Vote', 'SubjectConfirm', 'FinalConfirm'];

      if (logoutRouteNames.indexOf(this.$route.name || '') !== -1) {
        if (!this.IsAuthenticated) return;
        let canceled = await helper.cancelVoteStation();
        if(canceled) {
          if (process.env.VUE_APP_MODE === 'CS') {
            this.$router.push({ name: 'Start' });
          }
          if (process.env.VUE_APP_MODE === 'SA') {
            this.$router.push({ name: 'VoterAssign' });
          }
        }
        return;
      }
    }

    if (this.$route.name === 'ThankYou') {
      helper.swalShowLoading();
      await Q.delay(500);
      if (process.env.VUE_APP_MODE === 'CS') {
        this.$router.push({ name: 'Start' });
      }
      if (process.env.VUE_APP_MODE === 'SA') {
        this.$router.push({ name: 'VoterAssign' });
      }
      if (process.env.VUE_APP_MODE === 'WEB') {
        this.$router.push({ name: 'Login' });
      }
      helper.close();
    }
  }
}
